import { PxdAgDatePickerEditorComponent } from "@app/shared/aggrid/pxd-ag-grid-datepicker-editor";
import { PXDDefaultExcelExportParams, PxdAgEditGridDefaultColumnDef, PxdAgGridColumnTypes, PxdAgGridExcelStyles, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions } from "@app/shared/aggrid/pxd-ag-grid-options";

export class SurfaceDevScheduleTaskPlanningGridOptions {
  public gridOptions: PxdAgGridOptions = {
    enableCharts: true,
    cellSelection: true,
    rowGroupPanelShow: 'always',
    defaultColDef: PxdAgEditGridDefaultColumnDef,
    statusBar: PxdAgGridStatusBarOptions,
    sideBar: PxdAgGridSideBarOptions,
    columnTypes: PxdAgGridColumnTypes,
    excelStyles: PxdAgGridExcelStyles,
    defaultExcelExportParams: PXDDefaultExcelExportParams,
    columnDefs: [
      { field: 'Description', headerName: 'Task', editable: false, cellClass: 'readonlycell' },
      { field: 'TargetCompletionDate', headerName: 'Target Complete Date', type: ['dateColumn'], editable: false, tooltipField: 'EquationValue', cellClass: 'ExcelDate readonlycell' },
      {
        field: 'ActualStartDate', headerName: 'Start Date', type: ['dateColumn'], cellClass: 'ExcelDate',
        cellEditorSelector: params => {
          return { component: PxdAgDatePickerEditorComponent };
        },
        filter: 'agDateColumnFilter',
        filterParams: {
          includeBlanksInEquals: false,
          includeBlanksInGreaterThan: false,
          includeBlanksInLessThan: false
        }
      },
      {
        field: 'ActualCompleteDate', headerName: 'End Date', cellClass: 'ExcelDate',
        type: ['dateColumn'],
        cellEditorSelector: params => {
          return { component: PxdAgDatePickerEditorComponent };
        },
        filter: 'agDateColumnFilter',
        filterParams: {
          includeBlanksInEquals: false,
          includeBlanksInGreaterThan: false,
          includeBlanksInLessThan: false
        }
      },
      { field: 'Comments' },
    ]
  };
}